import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEntry16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveEntry16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M6.031 6.795a.6.6 0 0 1-.6.6H1.553a.6.6 0 0 1 0-1.2H5.43a.6.6 0 0 1 .6.6M5.925 9.2a.6.6 0 0 1-.6.6H2.688a.6.6 0 1 1 0-1.2h2.637a.6.6 0 0 1 .6.6m8.516-.94a3.7 3.7 0 0 1-3.695 3.51l-.19-.005A3.7 3.7 0 0 1 7.05 8.26l-.005-.19a3.7 3.7 0 0 1 3.701-3.701l.19.005a3.7 3.7 0 0 1 3.51 3.696zm-1.195-.19a2.5 2.5 0 1 0-5.001 0 2.5 2.5 0 0 0 5.001 0"
            />
        </svg>
    );
}
export default memo(IconMoveEntry16);
